import React, { ReactNode, MutableRefObject } from 'react';

import { SCREENS, AWAITING_RESPONSE_TYPE } from '@core/assistant/interfaces';
import { IMessage } from '@core/assistant/interfaces';
import { LinearScriptPlayer } from './scriptPlayer/linearScriptPlayer';
import { IAssistantScript } from '@interfaces/assistantScript';

export interface IAssistantContext {
  activeScreen: SCREENS;
  setActiveScreen: React.Dispatch<React.SetStateAction<SCREENS>>;
  setNavigationHistory: React.Dispatch<React.SetStateAction<SCREENS[]>>;
  open: boolean;
  awaitingResponseType: AWAITING_RESPONSE_TYPE;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  //setAwaitingResponse: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendRequest: (question: string) => Promise<void>;
  chatHistory: IMessage[];
  audioPromptHistory: string[];
  //generateGreetingsAudio: () => void;
  //playBackOnFirstTime: () => void;
  navigate: (scren: SCREENS, navigateBack?: boolean) => void;
  stopPlayback: () => void;
  isAIEnabledForEvent: () => boolean;
  isRecording: boolean;
  setIsRecording: React.Dispatch<React.SetStateAction<boolean>>;
  isMuted: boolean;
  setIsMuted: () => void;
  teleportToRegion: (regionName: string) => void;
  startFlow: (name: string) => void;
  linearScriptPlayerRef: MutableRefObject<LinearScriptPlayer | undefined>;
  isAudioPlaybackActiveRef: MutableRefObject<boolean | undefined>;
  isAudioPlaybackActive: boolean;
  scripts: IAssistantScript[];
  fetchScripts: () => Promise<void>;
  fetchParticipantProgress: () => Promise<void>;
  handleSubmitUserFeedback: (isUserApproved: boolean) => Promise<void>;
  isDisplayUserFeedback: boolean;
  setIsDisplayUserFeedback: React.Dispatch<React.SetStateAction<boolean>>;
  resetProgress: () => Promise<void>;
  //setIsAudioPlaybackActive: React.Dispatch<React.SetStateAction<boolean>>;
  userName: string;
}

export interface IDebug {
  queryBedrockTest: () => void;
  generateAudioPlaybackTest: () => void;
  testKeyboard: () => void;
  sendWSMessage: (message: string) => void;
}

export interface IRecord {
  startRecording: () => Promise<void>;
  stopRecording: () => void;
}

export type ProviderProps = {
  children: ReactNode;
  currentRegionName: string | undefined;
  userName: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mytaverseEventRef: MutableRefObject<any>;
  sendWSRef: MutableRefObject<(message: any) => void>;
};

export enum SocketEventRequestType {
  bedrock = 'BedrockEvent',
  polly = 'PollyEvent',
  transcribeAudio = 'TranscribeAudioEvent',
  startTranscription = 'StartTranscriptionEvent',
  stopTranscription = 'StopTranscriptionEvent',
}

export enum SocketEventResponseType {
  bedrock = 'BedrockEvent',
  polly = 'PollyEvent',
  error = 'ErrorEvent',
  transcription = 'TranscriptionEvent',
}

export enum SocketEventDirection {
  request = 'SocketEventRequest',
  response = 'SocketEventResponse',
}
